import React from 'react';

import { Logos } from '../../data/Assets';

import { ImageAsset } from '../wrappers/ImageAsset';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='imm_quest_admin__auth_layout'>
      <div className='auth_screen_logo'>
        <ImageAsset src={Logos.Logo} alt="" className='fit_asset_max' />
      </div>
      <div className='auth__page_views'>
        {children}
      </div>
    </div>
  )
}

export default AuthLayout